import { createFileRoute } from '@tanstack/react-router';

import { GettingInsights } from 'features/get-started/GettingInsights';

export const Route = createFileRoute('/_authenticated/get-started/_get-started/getting-insights/')({
  component: GettingInsightsRoute
});

function GettingInsightsRoute() {
  return <GettingInsights />;
}
